import { WizardProvider } from '../../Wizard/WizardContext'
import { MultiStepWizard } from '../../MultiStepWizard/MultiStepWizard'
import { MultiStepWizardProps } from '../../MultiStepWizard/Types'
import { UploadVideo } from './UploadVideo/UploadVideo'
import { Values } from '../Types'
import { ChooseTemplate } from './ChooseTemplate/ChooseTemplate'
import { useState } from 'react'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { useImportMediaFiles, ONE_GB_IN_BYTES } from 'hooks/useImportMediaFiles'
import { CustomizeTopic } from './CustomizeTopic/CustomizeTopic'

interface VideoWizardProps extends MultiStepWizardProps {
  createDesign: (values: Values) => Promise<void>
}

export const VideoWizard = (props: VideoWizardProps) => {
  const { createDesign, schema, onSubmit, ...rest } = props
  const [selectedMediaFile, setSelectedMediaFile] = useState<IMediaFile | null>(null)
  const [isDownloading, setIsDownloading] = useState(false)
  const { uploadImageFiles, isUploading } = useImportMediaFiles(false, undefined, undefined, {
    maxFileSize: ONE_GB_IN_BYTES,
  })
  const [confirmedVideo, setConfirmedVideo] = useState(false)

  return (
    <WizardProvider schema={schema}>
      <MultiStepWizard.Root {...rest} schema={schema} onSubmit={onSubmit}>
        <UploadVideo
          createDesign={createDesign}
          uploadVideo={uploadImageFiles}
          setIsDownloading={setIsDownloading}
          setSelectedMediaFile={setSelectedMediaFile}
          isDownloading={isUploading || isDownloading}
        />
        {selectedMediaFile && (
          <CustomizeTopic
            selectedMediaFile={selectedMediaFile}
            createDesign={createDesign}
            setConfirmedVideo={setConfirmedVideo}
          />
        )}
        {selectedMediaFile && confirmedVideo && (
          <ChooseTemplate selectedMediaFile={selectedMediaFile} createDesign={createDesign} />
        )}
      </MultiStepWizard.Root>
    </WizardProvider>
  )
}
